import React, { useEffect } from "react"
import { Button, Table } from "react-bootstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { fetchStudentAction } from "../../pages/student/studentAction"

const StudentTable = () => {
  const dispatch = useDispatch()
  const { fetchedStudent } = useSelector((state) => state.student)
  useEffect(() => {
    dispatch(fetchStudentAction())
  }, [dispatch])
  return (
    <div>
      <h5>Under Development</h5>
      {/* <div className="">{fetchedStudent?.length} Students found!</div>
      <div className="table-responsive">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Status</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Email</th>

              <th>Info</th>
            </tr>
          </thead>
          <tbody>
            {!!fetchedStudent.length &&
              fetchedStudent?.map((students, index) => (
                <tr key={students._id}>
                  <td>{index + 1}</td>
                  <td>{students.status}</td>
                  <td>{`${students.fName} ${students.lName}`}</td>
                  <td>{students?.mobile} </td>
                  <td>{students?.email} </td>

                  <td>
                    <Link to={`/studentInfo/${students._id}`}>
                      <Button variant="success">Info</Button>
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div> */}
    </div>
  )
}

export default StudentTable
